import { SVGProps, Ref, forwardRef } from 'react';

export const LightbulbOnOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4a4 4 0 0 1 3.64 5.66l-.867 1.911c-.197.446-.304.708-.327.813-.045.21-.046.411-.046.813v.403c0 1.8-1.2 2.4-2.4 2.4s-2.4-.6-2.4-2.4v-.403c0-.402 0-.603-.046-.813s-.429-1.049-1.195-2.725A4 4 0 0 1 8 4m-1 9.6c0 .563.171.737.246.8.12.1.362.2.754.2s.634-.1.754-.2c.066-.055.205-.196.24-.607L9 13.6v-.233H7zm1-8.2a2.6 2.6 0 0 0-2.367 3.677c.38.834.673 1.472.874 1.927q.151.341.247.576c.037.091.09.226.132.365l.006.022h2.216l.006-.022c.042-.14.095-.274.132-.365q.096-.236.247-.576c.201-.455.493-1.093.874-1.927A2.6 2.6 0 0 0 8 5.4"
                    fill="currentColor"
                />
                <path d="M2.646 7.3q-.045.345-.046.7.001.355.046.7H0V7.3z" fill="currentColor" />
                <path d="M16 8.7h-2.646q.045-.345.046-.7-.001-.355-.046-.7H16z" fill="currentColor" />
                <path d="M4.709 3.719a5.4 5.4 0 0 0-.99.99L1.848 2.838l.99-.99z" fill="currentColor" />
                <path d="m14.151 2.838-1.87 1.871a5.4 5.4 0 0 0-.991-.99l1.872-1.87z" fill="currentColor" />
                <path d="M8.7 2.646A5.5 5.5 0 0 0 8 2.6q-.355.001-.7.046V0h1.4z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
LightbulbOnOutlinedSize16Glyph.displayName = 'LightbulbOnOutlinedSize16Glyph';
